import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/user.ts

var user_exports = {};

__export(user_exports, {
  changePassword: function changePassword() {
    return _changePassword;
  },
  getChatRooms: function getChatRooms() {
    return _getChatRooms;
  },
  getMe: function getMe() {
    return _getMe;
  },
  getUnreadCount: function getUnreadCount() {
    return _getUnreadCount;
  },
  updateMe: function updateMe() {
    return _updateMe;
  },
  uploadDeviceInfo: function uploadDeviceInfo() {
    return _uploadDeviceInfo;
  }
});

var _getMe = function _getMe(data) {
  return fetcher_default.get("/v4/users/me", data);
};

var _updateMe = function _updateMe(data) {
  return fetcher_default.put("/v4/users/me", data);
};

var _getUnreadCount = function _getUnreadCount() {
  return fetcher_default.get("/v4/users/me/unread_count");
};

var _uploadDeviceInfo = function _uploadDeviceInfo(payload) {
  return fetcher_default.post("/v4/users/me/update_device", payload);
};

var _getChatRooms = function _getChatRooms() {
  return fetcher_default.get("/v4/users/me/chatrooms");
};

var _changePassword = function _changePassword(payload) {
  return fetcher_default.post("/v4/users/me/change_password", payload);
};

export { _getMe as getMe, _updateMe as updateMe, _getUnreadCount as getUnreadCount, _uploadDeviceInfo as uploadDeviceInfo, _getChatRooms as getChatRooms, _changePassword as changePassword, user_exports };